import Swiper from 'swiper';
const tabsSlider = document.querySelectorAll(".tabs-slider");

if(tabsSlider){
    tabsSlider.forEach((content) => {
        const contentBlocks = content.querySelectorAll(".tabs-slider__block");
        const init = () => {
            contentBlocks.forEach((el) => {
                const slides = el.querySelectorAll(".tabs-slider__slide");
                if(slides.length > 2){
                    const swiper = new Swiper (el.querySelector(".slider"), {
                        slidesPerView: 1,
                        loop: true,
                        centeredSlides: true,
                        navigation: {
                          nextEl: '.next',
                          prevEl: '.prev',
                        },
                        pagination: {
                            el: el.querySelector('.slider-pagination'),
                          },
                        breakpoints: {
                            1024: {
                              slidesPerView: 2.1,
                              spaceBetween: 40
                            }
                          }
                      })
                } else{
                    el.classList.add("is-list")
                }
            })
        }
        init();
        
        content.querySelectorAll(".tabs-slider__button").forEach((el) => {
            el.addEventListener("click", () => {
                content.querySelectorAll(".tabs-slider__button").forEach((el) => {
                    el.classList.remove("is-active");
                });
                el.classList.add("is-active");

                contentBlocks.forEach((block) => {
                    if(el.dataset.category == block.dataset.category){
                        block.classList.add("is-active");
                        if(block.querySelector(".slider").swiper){
                            block.querySelector(".slider").swiper.destroy(true, true);
                        }
                        init();
                    }
                    else{
                        block.classList.remove("is-active");
                    }
                });
            })
        });
    });
};